<div class="h-100">
	<div class="card text-left h-100 m-0">
		<div class="card-header bg-light">
			<h4 class="card-title mb-0">{{ titulo }}</h4>
		</div>
		<div class="p-4 wrapper">
			<div class="row">
				<div class="col-sm-6">
					<label for="validationCustom01" class="form-label">Nº Solicitação Técnica</label>
					<input type="text" maxlength="15" name="nSolicitacaoTecnica" class="form-control form-control-sm"
						id="nSolicitacaoTecnica" [(ngModel)]="model.numero" placeholder="-" disabled
						[ngModelOptions]="{ standalone: true }" />
				</div>
				<div class="col-sm-6">
					<label for="validationCustom02" class="form-label">Prazo</label>
					<input type="text" name="prazo" class="form-control form-control-sm" id="nSolicitacao" bsDatepicker
						[bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }" [(ngModel)]="model.prazo" disabled
						[ngModelOptions]="{ standalone: true }" />
				</div>
			</div>

			<div class="row mt-2">
				<div class="col-sm-12">
					<label for="validationCustom05" class="form-label">Assunto:
					</label>
					<input type="text" name="assunto" class="form-control" id="assunto" 
						[(ngModel)]="model.assunto" disabled
						[ngModelOptions]="{ standalone: true }" />
				</div>
			</div>

			<div class="row mt-2">
				<div class="col-sm-12">
					<label for="validationCustom05" class="form-label">Descrição:
					</label>
					<div class="form-control" [innerHTML]="model.descricao"
						style="min-height: 150px; max-height: 300px; overflow-y: auto;">
					</div>
				</div>
			</div>

			<div class="row mt-2">
				<div class="col-sm-12">
					<label for="validationCustom06" class="form-label">Visualizar Itens</label>
					<div class="mat-elevation-z1">
						<table mat-table [dataSource]="dataSourceItems" matSortDisableClear #tabela1="matSort" matSort
							matSortDirection="asc">
							<tr mat-header-row *matHeaderRowDef="[
									'numero',
									'titulo',
									'status',
									'statusAvaliacao',
									'actions'
								]" class="bg-light"></tr>

							<ng-container matColumnDef="numero">
								<th mat-header-cell *matHeaderCellDef mat-sort-header>
									Nº Item
								</th>
								<td mat-cell *matCellDef="let element" class="text">
									{{ element?.numero }}
								</td>
							</ng-container>

							<ng-container matColumnDef="titulo">
								<th mat-header-cell *matHeaderCellDef mat-sort-header>
									Titulo
								</th>
								<td mat-cell *matCellDef="let element" class="text">
									{{ element?.titulo }}
								</td>
							</ng-container>

							<ng-container matColumnDef="status">
								<th mat-header-cell *matHeaderCellDef mat-sort-header>
								Status
								</th>
								<td mat-cell *matCellDef="let element">
								<span *ngIf="!element?.statusCalculado">-</span>
								<span *ngIf="element?.statusCalculado?.codigo === 1"
									class="badge bg-success text-xs">{{element?.statusCalculado?.descricao}}</span>
								<span *ngIf="element?.statusCalculado?.codigo === 2"
									class="badge bg-secondary text-xs">{{element?.statusCalculado?.descricao}}</span>
								<span *ngIf="element?.statusCalculado?.codigo === 3"
									class="badge bg-danger text-xs">{{element?.statusCalculado?.descricao}}</span>
								<span *ngIf="element?.statusCalculado?.codigo === 4"
									class="badge bg-info text-xs">{{element?.statusCalculado?.descricao}}</span>
								<span *ngIf="element?.statusCalculado?.codigo === 5"
									class="badge bg-warning text-xs">{{element?.statusCalculado?.descricao}}</span>
								<span *ngIf="element?.statusCalculado?.codigo === 6"
									class="badge bg-primary text-xs">{{element?.statusCalculado?.descricao}}</span>
								<span *ngIf="element?.statusCalculado?.codigo === 7"
									class="badge bg-info text-xs">{{element?.statusCalculado?.descricao}}</span>

								<i *ngIf="element?.statusCalculado?.codigo === 3" class="fas fa-info-circle"
									[matTooltip]="formatarTooltipCanc(element)" matTooltipClass="tooltip-avaliacao"
									matTooltipPosition="above" style="cursor: pointer; margin-left: 0.5rem;">
								</i>

								</td>
							</ng-container>

							<ng-container matColumnDef="statusAvaliacao">
								<th mat-header-cell *matHeaderCellDef mat-sort-header>
								Avaliação
								</th>
								<td mat-cell *matCellDef="let element">
								<i *ngIf="isStatusAvaliacaoVazio(element?.statusAvaliacao)" class="fas fa-minus text-muted"></i>
								<span *ngIf="element?.statusAvaliacao.codigo === 1"
									class="badge bg-info text-xs">{{element?.statusAvaliacao?.descricao}}</span>
								<span *ngIf="element?.statusAvaliacao?.codigo === 2"
									class="badge bg-warning text-xs">{{element?.statusAvaliacao?.descricao}}</span>
								<span *ngIf="element?.statusAvaliacao?.codigo === 3"
									class="badge bg-danger text-xs">{{element?.statusAvaliacao?.descricao}}</span>

								<i *ngIf="element?.comentarioAvaliacao" class="fas fa-info-circle"
									[matTooltip]="formatarTooltipAvaliacao(element)" matTooltipClass="tooltip-avaliacao"
									matTooltipPosition="above" style="cursor: pointer; margin-left: 0.5rem;">
								</i>

								</td>
							</ng-container>

							<ng-container cdkColumnDef="actions">
								<th mat-header-cell *matHeaderCellDef style="max-width: 60px" class="text-center">
									Ações
								</th>
								<td mat-cell *matCellDef="let element; let i = index" class="block">
									<div class="w-100 d-flex justify-content-center">
										<button type="button" (click)="
												modalVisulizaItem(element?.id)
											" class="btn btn-info btn-xs text-left">
											<i class="far fas fa-eye"></i>
										</button>
									</div>
								</td>
							</ng-container>

							<tr mat-row *matRowDef="
									let row;
									columns: [
										'numero',
										'titulo',
										'status',
										'statusAvaliacao',
										'actions'
									]
								"></tr>
						</table>
						<h5 class="table-no-data" [hidden]="dataSourceItems?.data?.length > 0">
							Nenhum registro encontrado
						</h5>
						<mat-paginator #TableOnePaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
						</mat-paginator>
					</div>
				</div>
			</div>
		</div>
		<div class="card-footer text-right">
			<button type="button" class="btn btn-default btn-sm" (click)="fechar()">
				<i class="fas fa-times"></i> Fechar
			</button>
		</div>
	</div>
</div>